import React, { useState } from "react";
import "./explorebox.scss";
import { explorearrow, explorearrowGreen } from "../../source";
import { Link } from "react-router-dom";
import { useWindowSize } from "react-use";

const ExploreBox = ({
  bgImg,
  count,
  title,
  description,
  bgColor = "#ff9900d9",
}) => {
  const [isHover, setIsHover] = useState(false);
  const {width} = useWindowSize();
  return (
    <>
      <Link
        to={() => false}
        className="explore_box_wrapper"
        style={{ background: `${bgColor}` }}
        onMouseOver={() => setIsHover(true)}
        onMouseOut={() => setIsHover(false)}
      >
        <img
          width={812}
          height={440}
          src={bgImg}
          alt="background"
          className="bg_img"
          loading="lazy"
        />
        <div className="count_arrow_wrap">
          <p className="explore_count">{count}</p>
          {/* <img
            width={65}
            height={65}
            src={width > 767 && isHover ? explorearrowGreen : explorearrow}
            alt="background"
            className={`explore_arrow ${isHover ? "active" : ""}`}
            loading="lazy"
          /> */}
        </div>
        <h2 className="section_heading72">{title}</h2>
        <p
          className="explore_desc"
          dangerouslySetInnerHTML={{ __html: description }}
        ></p>
      </Link>
    </>
  );
};

export default ExploreBox;
